// src/components/ui/button.js
import React, { useEffect, useState } from "react";
import { Button, Popconfirm, DatePicker } from 'antd';
import dayjs from 'dayjs';

export function InvoiceStatusCapture({ onConfirm, record_id, status }) {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setSelectedDate(dayjs());
  }, [visible])

  const handleConfirm = () => {
    if (selectedDate) {
      onConfirm(record_id, status, selectedDate.format('YYYY-MM-DD'));
    }
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  }

  return (
    <Popconfirm
      title={
        <>
          <div style={{ marginBottom: 8 }}>
            {`Choose ${status === 1 ? 'submit' : 'payment'} date:`}
          </div>
          <DatePicker
            value={selectedDate}
            onChange={setSelectedDate}
            style={{ width: '100%' }}
          />
        </>
      }
      open={visible}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      okText={
        status === 1? 
        'Submit' :
        'Mark Paid'
      }
      cancelText="Cancel"
    >
      <Button onClick={() => setVisible(true)}>{status === 1 ? 'Submit': 'Mark Paid'}</Button>
    </Popconfirm>
  )
}
